import { render } from "./TheGlobalDialogs.vue?vue&type=template&id=2925bacb&ts=true"
import script from "./TheGlobalDialogs.vue?vue&type=script&lang=ts"
export * from "./TheGlobalDialogs.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__